$(document).ready(function () {
 $('.slider-for').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        speed: 500,
        arrows: true,
        fade: false,
        centerMode: true,
        draggable: false,
       focusOnSelect:true,
        asNavFor: '.slider-nav',
         responsive: [
           {
            breakpoint: 767,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }
         ]
    });
    $('.slider-nav').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        asNavFor: '.slider-for',
        dots: false,
       fade: true,
        centerMode: true,
        focusOnSelect: true,
        slide: 'div'
    });


$('.compare-tabs ul li:nth-child(1) a').on('click', function (){
    $(this).closest('ul').next('.compare-tab-info').find('.tab-rte').removeClass('active');
    $(this).closest('ul').next('.compare-tab-info').find('.tab_1').addClass('active');  
    $(this).closest('ul').find('a').removeClass('active');
    $(this).addClass('active');
});

  $('.compare-tabs ul li:nth-child(2) a').on('click', function (){
    $(this).closest('ul').next('.compare-tab-info').find('.tab-rte').removeClass('active');
    $(this).closest('ul').next('.compare-tab-info').find('.tab_2').addClass('active');  
    $(this).closest('ul').find('a').removeClass('active');
    $(this).addClass('active');
});
$('.compare-tabs ul li:nth-child(3) a').on('click', function (){
    $(this).closest('ul').next('.compare-tab-info').find('.tab-rte').removeClass('active');
    $(this).closest('ul').next('.compare-tab-info').find('.tab_3').addClass('active');  
    $(this).closest('ul').find('a').removeClass('active');
    $(this).addClass('active');
});
  $('.compare-tabs ul li:nth-child(4) a').on('click', function (){
    $(this).closest('ul').next('.compare-tab-info').find('.tab-rte').removeClass('active');
    $(this).closest('ul').next('.compare-tab-info').find('.tab_4').addClass('active');  
    $(this).closest('ul').find('a').removeClass('active');
    $(this).addClass('active');
});
  $('.compare-tabs ul li:nth-child(5) a').on('click', function (){
    $(this).closest('ul').next('.compare-tab-info').find('.tab-rte').removeClass('active');
    $(this).closest('ul').next('.compare-tab-info').find('.tab_5').addClass('active');  
    $(this).closest('ul').find('a').removeClass('active');
    $(this).addClass('active');
});

});